import type { EditorView } from '@tiptap/pm/view';
import { liftListItem, sinkListItem } from '@tiptap/pm/schema-list';

export const TAB_CHARACTER = '\t';
export const TAB_SIZE = 8;

export const insertTabAtSelection = (value: string, selectionStart: number, selectionEnd: number) => ({
  value: `${value.slice(0, selectionStart)}${TAB_CHARACTER}${value.slice(selectionEnd)}`,
  cursorPosition: selectionStart + TAB_CHARACTER.length,
});

const getSelectedListItemType = (view: EditorView) => {
  const listItemType = view.state.schema.nodes.listItem;
  if (!listItemType) return null;

  const { $from } = view.state.selection;

  for (let depth = $from.depth; depth > 0; depth -= 1) {
    if ($from.node(depth).type === listItemType) return listItemType;
  }

  return null;
};

export const handleRichTextTabKeyDown = (view: EditorView, event: KeyboardEvent) => {
  if (event.key !== 'Tab') return false;

  event.preventDefault();
  event.stopPropagation();

  const listItemType = getSelectedListItemType(view);
  if (listItemType) {
    const updateListLevel = event.shiftKey ? liftListItem(listItemType) : sinkListItem(listItemType);
    updateListLevel(view.state, view.dispatch, view);
    return true;
  }

  const { state, dispatch } = view;
  dispatch(state.tr.insertText(TAB_CHARACTER));

  return true;
};
